/* eslint-disable no-unused-vars */
/**
 * Basic route file, duplicate and rename depending if additional routes are required.
 * Note that the body class should match the file name.
 */

/* Import External Modules */
import Cookies from 'js-cookie';

/* Import Internal Modules */
import Accessibility from '../global/_accessibility';
import Navigation from '../global/_navigation';

/* Import Utils */
import { scrollListener, resizeListener } from '../util/_utilities';

/* Import Styles */
import styles from '../../sass/main.scss';

export default {
    init() {
        // JavaScript to be fired on all pages
        Navigation.init();
        Accessibility.init();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
